import { Alert, Button, Select, Space } from 'antd';
import useExistingPaymentMethodForm from './useExistingPaymentMethodForm.hook';
import { Container } from './ExistingPaymentMethodForm.styled';

export default function ExistingPaymentMethodForm({
  paymentMethods,
  subscriptionTypeId,
  amount,
  subscriptionParams,
  promotionCode,
}) {
  const { state, actions } = useExistingPaymentMethodForm({
    paymentMethods,
    subscriptionTypeId,
    amount,
    subscriptionParams,
    promotionCode,
  });
  return (
    <Container>
      <Select
        size="large"
        defaultValue={paymentMethods?.length ? paymentMethods[0].id : null}
        className="select"
        onSelect={actions.setSelectedPaymentMethodId}
        value={state.selectedPaymentMethodId}
      >
        {paymentMethods.map((paymentMethod) => (
          <Select.Option key={paymentMethod.id} value={paymentMethod.id}>
            **** **** **** {paymentMethod.last4}
          </Select.Option>
        ))}
      </Select>
      <Button
        type="primary"
        loading={state.processing}
        disabled={state.processing}
        size="large"
        onClick={actions.pay}
        className="pay-button"
      >
        Pay ${amount}
      </Button>
      {state.error ? (
        <Alert
          message={state.error}
          type="error"
          closable
          onClose={actions.closeError}
        />
      ) : null}
    </Container>
  );
}
